import React, { useEffect, useState } from 'react';
import Icon from '../Icon';
import * as S from './style';
import * as T from '../Typography';

const Copy = ({ inviteToken, tokenStyle }) => {
  const [copied, setCopied] = useState(false);

  const copyCodeToClipboard = () => {
    setCopied(false);
    const el = document.createElement('textArea');
    el.value = inviteToken;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    setCopied(true);
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 750);
    }
  }, [copied]);

  if (!inviteToken) {
    <T.P color="error">Missing Token.</T.P>;
  }

  return (
    <>
      <S.Wrapper>
        <T.P
          color={tokenStyle?.color || 'gray8'}
          bold
          style={{ ...tokenStyle }}
        >
          {inviteToken}
        </T.P>

        <S.CopyBtn ml="3" onClick={copyCodeToClipboard}>
          <T.P size="small" color="neutral90">
            COPY
          </T.P>
          <Icon icon="copy" color="neutral90" width="16" height="16" ml="1" />
        </S.CopyBtn>
      </S.Wrapper>
      {copied && (
        <Icon
          icon="tick"
          text="Copied"
          color="primary"
          width="16"
          height="16"
          mr="4"
          mt="2"
          style={{ justifyContent: 'flex-end' }}
        />
      )}
    </>
  );
};

export default Copy;
